/**
 * Always renders a `<video>`, which can carry a className. There is no
 * configuration that changes this.
 */
export const resolveRendersOwnElement = (): boolean => true;
